export default __webpack_public_path__ + "static/media/hadships.e9b0c658.png";